import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useModel } from "hooks/useModel";
import styles from "./ChatList.module.scss";
import { fetchTopics } from "../../store/TopicActions";
import { useAxios } from "myAxios";
import ScrollContainer from "components/common/ScrollList";
import ChatListContent from "./ChatListContent";

const ChatList = (props: { hide?: boolean }) => {
  const {
    setChatlist,
    hasMore,
    setHasMore,
    current,
    setCurrent,
    setSelectKey,
    selectedKey,
    setUnsendMessages,
  } = useModel("aichat");
  const axios = useAxios();
  const { hide = false } = props;

  useEffect(() => {
    setUnsendMessages([]);
  }, [selectedKey, setUnsendMessages]);

  const onLoadMore = async () => {
    const res = await fetchTopics(axios, 20, current);
    setCurrent(current + 1);
    setChatlist((prev) => {
      const merged = [...prev, ...res].reduce((map, item) => {
        const existing = map.get(item.id);
        if (!existing) {
          map.set(item.id, item);
          return map;
        }
        const existingContent = existing.content;
        const incomingContent = item.content;
        const existingHasContent = Array.isArray(existingContent)
          ? existingContent.length > 0
          : !!existingContent;

        map.set(item.id, {
          ...existing,
          ...item,
          content: existingHasContent ? existingContent : incomingContent,
        });
        return map;
      }, new Map<string, any>());

      return Array.from(merged.values());
    });
    setHasMore(res?.[0]?.hasMore || false);
  };

  return (
    <Box className={styles.chatList}>
      {!hide && (
        <Box
          className={styles.newChat}
          onClick={() => setSelectKey(null)}
        >
          <img
            src="/aichat/write.svg"
            alt=""
            style={{ marginRight: 8 }}
          />
          New chat
        </Box>
      )}
      <ScrollContainer
        renderContent={<ChatListContent />}
        onLoadMore={onLoadMore}
        hasMore={hasMore}
        containerHeight={`calc(100% - ${hide ? "0px" : "34px"})`}
      />
    </Box>
  );
};

export default ChatList;
